import { Component, Input } from '@angular/core';
import { ClientReferralTask } from '../../../core/models/client-referral-task.model';
import { PrescriberIncorrectInformationPromptComponent } from '../../../shared/components/prescriber-incorrect-information-prompt/prescriber-incorrect-information-prompt.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { PrescriberOfficesScrollableComponent } from '../../../shared/components/prescriber-offices-scrollable/prescriber-offices-scrollable.component';
import { ClientTaskEncountersComponent } from '../client-task-encounters/client-task-encounters.component';
import { ClientReferralTaskRelatedTasksComponent } from '../client-referral-task-related-tasks/client-referral-task-related-tasks.component';
import { PatientPrescriberConsultNotesComponent } from '../patient-prescriber-consult-notes/patient-prescriber-consult-notes.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-client-referral-task-details',
    templateUrl: './client-referral-task-details.component.html',
    styleUrls: ['./client-referral-task-details.component.scss'],
    imports: [PrescriberIncorrectInformationPromptComponent,
              PrescriberNameComponent,
              PrescriberOfficesScrollableComponent,
              ClientTaskEncountersComponent,
              ClientReferralTaskRelatedTasksComponent,
              PatientPrescriberConsultNotesComponent,
              MatProgressSpinner]
})
export class ClientReferralTaskDetailsComponent {
  @Input() task: ClientReferralTask;
}
